import styled, { css } from 'styled-components'

interface PropsLink {
  marginTop: Number;
  marginBottom: Number;
  marginLeft: Number;
  marginRight: Number;
  disabled: Boolean;
  icon: Boolean;
  display: string;
}

export const Link = styled.a<PropsLink>`
  position: relative;
  text-decoration: none;
  cursor: pointer;
  margin-top: ${(props) => `${props.marginTop}px`};
  margin-bottom: ${(props) => `${props.marginBottom}px`};
  margin-left: ${(props) => `${props.marginLeft}px`};
  margin-right: ${(props) => `${props.marginRight}px`};
  color: ${(props) => props.color} !important;
  ${(props) => props.theme};

  &::after {
    content: "";
    position: absolute;
    cursor: pointer;
    transition-duration: ${(props) => props.theme.motion.transitionDuration}; 
    transition-timing-function: ${(props) => props.theme.motion.transitionTimingFunction};
  }

  ${(props) =>
    props.icon
      ? css`
          display: inline-flex;
          .tmp-link__icon {
            ${(props) => props.theme.icon}
            ${(props) => props.theme.motions};
          }
          &:hover {
            .tmp-link__icon {
              ${(props) => props.theme.states.hover.icon}
            }
          }
        `
      : css`
          &::after {
            content: "";
            position: absolute;
            left: 50%;
            bottom: 0;
            width: 0;
            background-color: currentColor;
            ${(props) => props.theme.underline};
            ${(props) => props.theme.motions};
          }
          &:hover {
            ${(props) => props.theme.states.hover};
            &::after {
              left: 0;
              width: 100%;
            }
          }
        `}

  &:focus{
    ${(props) => props.theme.states.focus};
  }
  ${(props) =>
    props.disabled &&
    css`
      pointer-events: none;
      cursor: default;
      ${(props) => props.theme.states.disabled};
    `};
`;
